import { useCallback } from 'react';

import { useLocation } from 'react-router';

import { useNavigate } from '@change-corgi/core/react/router';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { COMPLETE_TASK_ERROR_MAP, useCompleteTask } from 'src/app/pages/starterDashboardV2/shared/hooks';

type UseCompleteTaskByCheckboxReturn = (taskId: string) => () => Promise<void>;

export function useCompleteTaskByCheckbox(): UseCompleteTaskByCheckboxReturn {
	const {
		actions: { refreshData },
	} = useStarterDashboardV2PageData();

	const navigate = useNavigate();
	const { pathname, search } = useLocation();
	const { mutate: completeTask } = useCompleteTask({
		// TODO: Implement tracking for checkbox complete
		onError: (error) => {
			if (error === COMPLETE_TASK_ERROR_MAP.UNAUTHORIZED_ERROR.code) {
				const params = encodeURIComponent(`${pathname}${search}`);
				navigate(`/login_or_join/redirected?redirectTo=${params}`);
			}
		},
		onSuccess: () => {
			refreshData();
		},
	});

	return useCallback(
		(taskId: string) => {
			return async () => {
				await completeTask(taskId);
			};
		},
		[completeTask],
	);
}
